export default __webpack_public_path__ + "static/media/snd_00012.52a61da2.mp4";